import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "src/hooks/useAuth";
//components
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import HorarioAtendimentoAutomacao from "../components/HorarioAtendimentoAutomacao";
// ui
import { Divider } from "@mui/material";
import { RowInput } from "src/components/forms/RowInput";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { Switch } from "src/@/components/ui/switch";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Input } from "src/@/components/ui/input";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
//actions
import v2_actionListSectorsByClient from "src/actions/v2/cliente/v2_actionListSectorsByClient";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import { SwitchInput } from "src/components/ui-component/switch/Switch";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";
import { formatarCanaisParaSelect } from 'src/utils/canaisDisparo';

const HORARIOS = [

  "06:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
]

const CardResumoConversa = ({ actionState, changeActionState, actionPhase, user, diasSemana }) => {
  const { t } = useTranslation('automation');
  const { cliente } = useAuth();
  const [configCrm, setConfigCrm] = useState(null);

  const TIME_UNITS = [
    { label: t('actionForms.common.timeUnitMinutes', 'Minuto(s)'), value: 1 },
    { label: t('actionForms.common.timeUnitHours', 'Hora(s)'), value: 60 },
    { label: t('actionForms.common.timeUnitDays', 'Dia(s)'), value: 1440 },
    { label: t('actionForms.common.timeUnitWeeks', 'Semana(s)'), value: 10080 },
    { label: t('actionForms.common.timeUnitMonths', 'Mês(es)'), value: 43200 },
  ];

  const STATUS = [
    {
      value: "Atendendo",
      label: t('actionForms.common.statusAttending', 'Atendendo')
    },
    {
      value: "Avaliando",
      label: t('actionForms.common.statusEvaluating', 'Avaliando')
    },
    {
      value: "Pendente",
      label: t('actionForms.common.statusInQueue', 'Em Fila')
    },
    {
      value: "Geral",
      label: t('actionForms.common.statusInBot', 'No bot')
    },
    {
      value: "Finalizado",
      label: t('actionForms.common.statusFinished', 'Finalizado')
    }
  ];

  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [canais, setCanais] = useState([]);

  const [selectedPipe, setSelectedPipe] = useState(null);
  const [selectedPhase, setSelectedPhase] = useState(null); // Use null instead of an empty string



  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  let departmentsFormatted = departments?.map((department) => {
    return {
      value: department._id,
      label: department.nome_setor
    }
  });

  let canaisFormatted = formatarCanaisParaSelect(canais, { usarCanalId: true });

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user?.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }


  async function getListSectors() {
    try {
      const response = await v2_actionListSectorsByClient(user?.clienteId);
      setDepartments(response.data.data)
    } catch (error) {
      console.log(error);
    }
  }


  async function buscarListaCanais() {
    try {
      const response = await actionListaCanaisPorCliente(cliente._id);
      setCanais(response.data.data || []);
    } catch (error) {
      console.error("Erro ao buscar lista de canais:", error);
    }
  }

  useEffect(() => {
    getUsers();
    getListSectors();
    buscarListaCanais();
  }, []);


  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (actionState?.pipelineId) {
      buscarConfigCrm(`?pipeline_id=${actionState.pipelineId}`);
    } else {
      buscarConfigCrm();
    }
  }, [actionState]);



  return (
    <Card className="w-full">
      <CardHeader>
        <LabelFromAction>{actionPhase.name}</LabelFromAction>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 flex gap-2 flex-col">
          <div>
            <RowInput
              isRequired={true}
              label={t('actionForms.common.channelLabel', 'Canal')}
              info={t('actionForms.common.channelInfo', 'Canais que estão atrelados ao chat')}
              input={
                <MultiSelect
                  options={canaisFormatted}
                  onValueChange={(e) =>
                    changeActionState({ name: "chatChannels", value: e })
                  }
                  defaultValue={actionState.chatChannels}
                  placeholder={t('actionForms.common.selectChannelsPlaceholder', 'Selecionar canais')}
                  variant="inverted"
                  animation={2}
                  maxCount={3}
                />
              }
            />
          </div>

          <div>
            <RowInput
              isRequired={true}
              label={t('actionForms.common.chatStatusLabel', 'Status do Chat')}
              input={<MultiSelect
                options={STATUS.map((status) => ({
                  value: status.value,
                  label: status.label,
                }))
                }
                onValueChange={(e) => changeActionState({ name: "chatStatus", value: e })}
                defaultValue={actionState?.chatStatus}
                placeholder={t('actionForms.common.selectStatusPlaceholder', 'Selecionar status')}
                variant="inverted"
                animation={2}
                maxCount={3}
              />}
            />

          </div>


          {actionState.chatStatus?.length > 0 && (
            <div className="flex flex-col gap-2">
              <div>
                <RowInput
                  isRequired={true}
                  label={t('actionForms.cardResumoConversa.resumeExecutionTimeLabel', 'Horário de execução do resumo da conversas')}
                  input={<div className="flex gap-2">

                    <Select
                      value={actionState?.timeResume}
                      onValueChange={(selectedValue) => {
                        changeActionState({ name: "timeResume", value: selectedValue });
                      }}
                    >
                      <SelectTrigger className="w-1/2">
                        <SelectValue placeholder={t('actionForms.cardResumoConversa.selectTimePlaceholder', 'Selecione uma horário')} />
                      </SelectTrigger>
                      <SelectContent>
                        {HORARIOS.map((unit) => (
                          <SelectItem key={unit} value={unit}>
                            {unit}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>}
                />

              </div>


              <div className="mt-4">
                <RowInput
                  isRequired={true}
                  label={t('actionForms.cardResumoConversa.resumeSendPeriodLabel', 'Período de envio do resumo')}
                  input={<div className="flex gap-4">
                    <div className="flex items-center space-x-2">
                      <input
                        type="radio"
                        id="periodSendResume-today"
                        name="periodSendResume"
                        value="today"
                        checked={actionState?.periodSendResume === "today"}
                        onChange={(e) => changeActionState({ name: "periodSendResume", value: e.target.value })}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                      />
                      <label htmlFor="periodSendResume-today" className="text-sm font-medium text-gray-700">
                        {t('actionForms.cardResumoConversa.periodToday', 'Dia atual')}
                      </label>
                    </div>
                    <div className="flex items-center space-x-2">
                      <input
                        type="radio"
                        id="periodSendResume-yesterday"
                        name="periodSendResume"
                        value="yesterday"
                        checked={actionState?.periodSendResume === "yesterday"}
                        onChange={(e) => changeActionState({ name: "periodSendResume", value: e.target.value })}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                      />
                      <label htmlFor="periodSendResume-yesterday" className="text-sm font-medium text-gray-700">
                        {t('actionForms.cardResumoConversa.periodYesterday', 'Dia anterior')}
                      </label>
                    </div>
                  </div>}
                />
              </div>

              <div className="text-sm font-semibold bg-slate-100 p-2 rounded-md mt-4">
                {t('actionForms.common.filtersHeading', 'Filtros')}
              </div>


              <div className="flex flex-col gap-2">
                {actionState.chatStatus.includes("Pendente") && (
                  <RowInput
                    label={t('actionForms.common.chatDepartmentsLabel', 'Setores do chat')}
                    info={t('actionForms.common.chatDepartmentsInfo', 'Setores que estão atrelados ao chat')}
                    input={
                      <MultiSelect
                        options={departmentsFormatted}
                        onValueChange={(e) =>
                          changeActionState({ name: "chatDepartamentsAssign", value: e })
                        }
                        defaultValue={actionState.chatDepartamentsAssign}
                        placeholder={t('actionForms.common.selectDepartmentsPlaceholder', 'Selecionar setores')}
                        variant="inverted"
                        animation={2}
                        maxCount={3}
                      />
                    }
                  />
                )}

                <RowInput
                  label={t('actionForms.common.chatUsersLabel', 'Usuários do chat')}
                  info={t('actionForms.common.chatUsersInfo', 'Usuários que estão atrelados ao chat')}
                  input={
                    <MultiSelect
                      options={usersFormatted}
                      onValueChange={(e) =>
                        changeActionState({ name: "chatUsersAssign", value: e })
                      }
                      defaultValue={actionState.chatUsersAssign}
                      placeholder={t('actionForms.common.selectUsersPlaceholder', 'Selecionar usuarios')}
                      variant="inverted"
                      animation={2}
                      maxCount={3}
                    />
                  }
                />
              </div>
            </div>
          )}



        </div>
      </CardContent>
    </Card>
  );
};

export default CardResumoConversa;
